import React, { useState } from 'react';
import '../styles/MembershipFormModal.css';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  contactNumber: '',
  country: '',
  message: '',
};

const countries = [
  '', 'United Arab Emirates', 'Saudi Arabia', 'Qatar', 'Kuwait', 'Bahrain', 'Oman', 'India', 'Pakistan', 'United Kingdom', 'United States', 'Other'
];

const MembershipFormModal = ({ open, onClose }) => {
  const [form, setForm] = useState(initialState);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  if (!open) return null;

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.firstName || !form.lastName || !form.email || !form.contactNumber || !form.country) {
      setError('Please fill in all required fields.');
      return;
    }
    setError('');
    setLoading(true);
    setSuccess(false);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/membership`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) {
        const data = await res.json();
        setError(data.error || 'Submission failed. Please try again.');
        setLoading(false);
        return;
      }
      setSuccess(true);
      setForm(initialState);
      setLoading(false);
      setTimeout(() => {
        setSuccess(false);
        onClose();
      }, 3000);
    } catch (err) {
      setError('Network error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="membership-modal-overlay">
      <div className="membership-modal">
        <button className="modal-close-btn" onClick={onClose} disabled={loading}>&times;</button>
        <h2>Membership Form</h2>
        <p className="modal-desc">Please complete the form below for our membership team to reach out.</p>
        <form onSubmit={handleSubmit} className="membership-form">
          <div className="form-row">
            <label className="form-col">First Name*
              <input name="firstName" value={form.firstName} onChange={handleChange} required disabled={loading} />
            </label>
            <label className="form-col">Last Name*
              <input name="lastName" value={form.lastName} onChange={handleChange} required disabled={loading} />
            </label>
          </div>
          <div className="form-row">
            <label className="form-col">Email*
              <input name="email" type="email" value={form.email} onChange={handleChange} required disabled={loading} />
            </label>
            <label className="form-col">Contact Number*
              <input name="contactNumber" value={form.contactNumber} onChange={handleChange} placeholder="Eg: +61455***67" disabled={loading} required />
            </label>
            <label className="form-col">Country*
              <select name="country" value={form.country} onChange={handleChange} disabled={loading} required>
                {countries.map(c => <option key={c} value={c}>{c || 'Select'}</option>)}
              </select>
            </label>
          </div>
          <label>Message
            <textarea name="message" value={form.message} onChange={handleChange} disabled={loading} />
          </label>
          {error && <div className="form-error">{error}</div>}
          {success && <div className="form-success">Thank you for your submission!</div>}
          <button type="submit" className="modal-send-btn" disabled={loading}>{loading ? 'Sending...' : 'Send'}</button>
        </form>
      </div>
    </div>
  );
};

export default MembershipFormModal; 